<template>
  <div class="item-controls">
    <template v-if="!isGift">
      <p v-if="buyOnlyPrePaidInfoText" class="item-controls__status _pre-order">
        {{ buyOnlyPrePaidInfoText }}
      </p>
      <p v-else-if="cntInfoText" class="item-controls__status _cnt-info">
        {{ cntInfoText }}
      </p>
    </template>
    <div class="item-controls__controls">
      <div v-if="showCounter && isBasket" class="item-controls__counter">
        <counter-control
          :max-value="maxCount"
          :values="count"
          size="small"
          @change="handlerChangeCount"
        />
        <div v-if="count > 1" class="item-controls__counter-info">
          {{ count }} шт x
          {{ mainPriceFormatted }}
        </div>
      </div>
      <button-control
        v-if="showChangeGift && isGift"
        class="item-controls__main-button"
        size="small"
        type="secondary"
        is-block
        @click="handlerClickChangeGift"
      >
        Выбрать другой
      </button-control>

      <add-to-basket-button
        v-else-if="!isBasket && isAvailable && !isCertificate && !isPreOrder"
        class="item-controls__main-button"
        :product-id="productId"
        :is-loading="isLoadingAddToBasket"
        @addToBasketItem="handlerAddToBasketItem"
        @changeTab="handlerChangeTab"
      />
      <card-main-button
        v-else-if="!isBasket && (isCertificate || isPreOrder || !isAvailable)"
        class="item-controls__main-button"
        :link="productLink"
        :product-id="productId"
        :is-pre-order="isPreOrder"
        :is-certificate="isCertificate"
        :is-not-available="!isAvailable"
        :quantity="1"
        @clickNotAvailable="handlerClickNotAvailable"
      />
      <button
        class="item-controls__button-control"
        type="button"
        :disabled="isDisabledDeleted"
        @click.prevent="handlerRemoveItem"
      >
        <trash24
          class="item-controls__icon"
          :width="24"
          :height="24"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';
import { Counter, ButtonControl } from '@book24/ui-components';

import { priceFormatted } from '@/utils/formatters/formattedPrice';

import useCount from '@/compositions/useCount';
import useControlsItem from '@/compositions/useControlsItem';

import Trash24 from '@/assets/sprite/svg/24/Trash_24.svg';
import AddBookmark24 from '@/assets/sprite/svg/24/Add_bookmark_24.svg';
import CardMainButton from '@/components/ProductCard/CardMainButton/index.vue';
import AddToBasketButton from '@/components/AddToBasketButton/index.vue';

export default defineComponent({
  name: 'ItemControls',
  components: {
    CounterControl: Counter,
    ButtonControl,
    Trash24,
    AddBookmark24,
    CardMainButton,
    AddToBasketButton,
  },
  props: {
    productId: { type: [Number, String], required: true },
    categoryId: { type: [Number, String], required: true },
    productLink: { type: [Number, String], required: true },
    amount: { type: Object, default: () => ({ discounted: 0, total: 0 }) },
    buyOnlyPrePaidInfoText: { type: String, default: '' },
    cntInfoText: { type: String, default: '' },
    isGift: { type: Boolean, default: false },
    isBasket: { type: Boolean, default: true },
    maxCount: { type: Number, default: 1 },
    quantityInBasket: { type: Number, default: 1 },
    showCounter: { type: Boolean, default: true },
    isDisabledDeleted: { type: Boolean, default: false },
    showChangeGift: { type: Boolean, default: false },
    isAvailable: { type: Boolean, default: true },
    isCertificate: { type: Boolean, default: true },
    isPreOrder: { type: Boolean, default: true },
    isLoadingAddToBasket: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const { count, handlerChangeCount } = useCount(props.quantityInBasket);
    const controlsItem = useControlsItem(props);

    const mainPriceFormatted = computed(() => priceFormatted(props.amount.discounted, { setFreeText: false }));

    const handlerClickChangeGift = () => {
      emit('clickChangeGift');
    };

    const handlerAddToBasketItem = () => {
      emit('addToBasketItem');
    };

    const handlerChangeTab = () => {
      emit('changeTab');
    };

    const handlerClickNotAvailable = () => {
      emit('clickNotAvailable');
    };

    return {
      ...controlsItem,
      count,
      mainPriceFormatted,
      handlerChangeCount,
      handlerClickChangeGift,
      handlerAddToBasketItem,
      handlerChangeTab,
      handlerClickNotAvailable,
    };
  },
});
</script>

<style lang="less">
.item-controls {
  &__status {
    .p();

    margin: 0;

    &._cnt-info {
      color: @red-error;
    }

    &._pre-order {
      color: @orange;
    }
  }

  &__controls {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    margin-top: @size-x2;
  }

  &__counter {
    max-width: 114px;
    margin-right: auto;
  }

  &__counter-info {
    .small();

    color: @gray-dark;
  }

  &__button-control {
    .button-reset();

    padding: @main-size;
    width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: @gray;
    transition: @A color;

    &._tap {
      color: darken(@gray, 12%);
    }

    &._active {
      color: @pink;

      &._tap {
        color: darken(@pink, 12%);
      }
    }
  }

  &__icon {
    fill: currentColor;
  }

  &__main-button {
    max-width: 142px;
    margin-right: auto;
  }
}
</style>
